import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NavigationGuardState {
    shouldBlock: boolean;
}

export const initialState: NavigationGuardState = {
    shouldBlock: false,
};

const navigationGuardSlice = createSlice({
    name: 'navigationGuard',
    initialState,
    reducers: {
        setShouldBlock: (state, action: PayloadAction<boolean>) => {
            state.shouldBlock = action.payload;
        },
        clearGuard: () => initialState,
    },
});

export const { setShouldBlock, clearGuard } = navigationGuardSlice.actions;
export default navigationGuardSlice.reducer;
